import React from 'react';

function UserAdd(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M10.75 16.375C10.75 13.2684 13.2684 10.75 16.375 10.75C19.4816 10.75 22 13.2684 22 16.375C22 19.4816 19.4816 22 16.375 22C13.2684 22 10.75 19.4816 10.75 16.375ZM16.375 12C13.9588 12 12 13.9588 12 16.375C12 18.7912 13.9588 20.75 16.375 20.75C18.7912 20.75 20.75 18.7912 20.75 16.375C20.75 13.9588 18.7912 12 16.375 12Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16.375 13.25C16.7202 13.25 17 13.5298 17 13.875V18.875C17 19.2202 16.7202 19.5 16.375 19.5C16.0298 19.5 15.75 19.2202 15.75 18.875V13.875C15.75 13.5298 16.0298 13.25 16.375 13.25Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.25 16.375C13.25 16.0298 13.5298 15.75 13.875 15.75H18.875C19.2202 15.75 19.5 16.0298 19.5 16.375C19.5 16.7202 19.2202 17 18.875 17H13.875C13.5298 17 13.25 16.7202 13.25 16.375Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.2134 11.7767C8.66864 11.1185 6.89677 11.2792 5.49567 12.2045C4.09457 13.1298 3.25114 14.6963 3.25 16.3754C3.24976 16.7206 2.96975 17.0002 2.62457 17C2.2794 16.9998 1.99977 16.7198 2 16.3746C2.00143 14.2759 3.05561 12.318 4.80681 11.1615C6.55801 10.0049 8.77262 9.80407 10.7033 10.6267C11.0209 10.762 11.1686 11.1291 11.0333 11.4467C10.898 11.7642 10.5309 11.912 10.2134 11.7767Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.1875 6.0625C4.1875 3.81884 6.00634 2 8.25 2C10.4937 2 12.3125 3.81884 12.3125 6.0625C12.3125 8.30616 10.4937 10.125 8.25 10.125C6.00634 10.125 4.1875 8.30616 4.1875 6.0625ZM8.25 3.25C6.6967 3.25 5.4375 4.5092 5.4375 6.0625C5.4375 7.6158 6.6967 8.875 8.25 8.875C9.8033 8.875 11.0625 7.6158 11.0625 6.0625C11.0625 4.5092 9.8033 3.25 8.25 3.25Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default UserAdd;
